import { render, staticRenderFns } from "./personal-rewards-renq.vue?vue&type=template&id=48bf66c4&scoped=true&"
import script from "./personal-rewards-renq.vue?vue&type=script&lang=js&"
export * from "./personal-rewards-renq.vue?vue&type=script&lang=js&"
import style0 from "./personal-rewards-renq.vue?vue&type=style&index=0&id=48bf66c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bf66c4",
  null
  
)

export default component.exports